exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".address-copy-checkbox[data-v-5aea1ca8]{border:none!important;margin-top:10px;height:auto;min-height:auto!important}.address-copy-checkbox input[type=checkbox][data-v-5aea1ca8]{width:auto}.address-copy-checkbox label[data-v-5aea1ca8]{color:#80808a}.expiry-section[data-v-5aea1ca8]{overflow:visible;box-sizing:content-box!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-5aea1ca8&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PaymentDetails.vue
// module id = 58
// module chunks = 0